import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { messagesListe, messageSupp } from "../actions/messageActions";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import MessageZone from "../MessageZone";
import "../Messagedistant.css";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";

const uri =
  process.env.REACT_APP_WX === "SERV1"
    ? process.env.REACT_APP_SERV_1
    : process.env.REACT_APP_SERV_2;

const Messagedistant = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { langue, societe } = location.state || {};

  const mliste = useSelector((state) => state.msg_distant);
  const { msg } = mliste;
  const [msgLoc, setMsgLoc] = useState([]);
  const [loading, setLoading] = useState(false);
  const [refreshing, setRefreshing] = useState(false);
  const [x, setX] = useState(0);

  const Cl = useSelector((state) => state.client);
  const { client } = Cl;

  const onRefresh = React.useCallback(async () => {
    setRefreshing(true);
    setX(x + 1);
    setRefreshing(false);
  }, [refreshing, x]);

  const msgLocMaj = async () => {
    console.log("msg uri:" + uri);
    const { data } = await axios.get(`${uri}/api/messages`);
    data?.forEach((item) => {
      if (item?.cod_user === client?.cod_cli) {
        setMsgLoc((prev) => [...prev, item]);
      }
    });
  };

  useEffect(() => {
    dispatch(messagesListe());
    if (x > 0) {
      setMsgLoc([]);
    }

    msg?.forEach((item) => {
      if (item?.cod_user === client?.cod_cli) {
        setMsgLoc((prev) => [...prev, item]);
      }
    });
  }, [client, x, dispatch]);

  const suppMsgHandler = async (id) => {
    confirmAlert({
      title: "Confirmation de suppression",
      message: "Voulez-vous vraiment supprimer ce message?",
      buttons: [
        {
          label: "Annuler",
          onClick: () => {},
        },
        {
          label: "Supprimer",
          onClick: async () => {
            await dispatch(messageSupp(id));
            await dispatch(messagesListe());
          },
        },
      ],
    });
  };

  const handleCreateMessage = () => {
    navigate("/MessageCree", { state: { langue, societe } });
  };

  return (
    <div className="message-distant-container">
      {loading ? (
        <div className="loading-overlay">
          <div className="loading-text">Veuillez patienter...</div>
        </div>
      ) : (
        <div className="message-distant-scroll-container">
          <button
            onClick={handleCreateMessage}
            className="message-distant-create-btn"
          >
            {langue === "F" ? "Créer un message" : "إنشاء رسالة"}
          </button>

          {msg &&
            msg.map(
              (wmsg, i) =>
                wmsg.cod_user === client.cod_cli && (
                  <div key={i} className="message-distant-item">
                    {wmsg.tokens.map((m, j) => (
                      <MessageZone
                        key={`${i}-${j}`}
                        le={
                          wmsg?.date_msg?.substring(0, 10) +
                          " " +
                          wmsg?.date_msg?.substring(11, 16)
                        }
                        rec={m.value}
                        objet={wmsg?.obj_msg}
                        contenu={wmsg?.text_msg}
                        onDelete={() => suppMsgHandler(wmsg._id)}
                      />
                    ))}
                  </div>
                )
            )}
        </div>
      )}
    </div>
  );
};

export default Messagedistant;
